import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';

@Injectable()
export class StocksProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async get(practiceId: string): Promise<StockSummaryDTO[]> {
        const url = this.configurationService.APIURL + '/api/stocks';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        return await this.http.get<StockSummaryDTO[]>(url, { params: params }).toPromise();
    }

    async correct(practiceId: string, stockCorrectionDTO: StockCorrectionDTO): Promise<object> {
        const url = this.configurationService.APIURL + '/api/stocks/correction';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        return await this.http.post(url, stockCorrectionDTO, { params: params }).toPromise();
    }

    async configureReplenishment(practiceId: string, replenishmentOptionsDTO: ReplenishmentOptionsDTO): Promise<object> {
        const url = this.configurationService.APIURL + '/api/stocks/replenishment';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        return await this.http.put(url, replenishmentOptionsDTO, { params: params }).toPromise();
    }

    async initializeStock(practiceId: string): Promise<object> {
        const url = this.configurationService.APIURL + '/api/stocks/init';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        return await this.http.post(url, {}, { params: params }).toPromise();
    }
}

export interface StockSummaryDTO {
    testReference: string;
    testName: string;
    testPrimaryColorHex: string;
    testSecondaryColorHex: string;

    count: number;

    autoReplenish: boolean;
    replenishThreshold: number;
    replenishQuantity: number;
}

export interface StockCorrectionDTO {
    testReference: string;
    newCount: number;
}

export interface ReplenishmentOptionsDTO {
    testReference: string;
    auto: boolean;
    threshold: number | null;
    quantity: number | null;
}
